import { message } from 'antd'
import { ValidatorRule } from 'rc-field-form/lib/interface'

export interface Data {
  code: string
  id: string
  dataType?: number
  name: string
  titleInfo?: string | JSX.Element
  titleExtra?: string | JSX.Element
  itemRuleVOList?: ItemRuleVO[]
  itemOptionVOList?: ItemOptionVO[]
  usable?: number // 1是启用 0是关闭
  vaildator?: ValidatorRule['validator']
  [key: string]: any
}

interface ItemRuleVO {
  errorTip: string
  ruleCode: string
  ruleType: number
  ruleValue: string
}
interface ItemOptionVO {
  optionValue: string
  optionText: string
}

export const getRules = (ruleCode: string, data: Data): string => {
  if (ruleCode) {
    const res = data.itemRuleVOList.filter((item) => item.ruleCode === ruleCode)
    return res.length ? res[0].ruleValue : 'false'
  } else {
    return 'false'
  }
}

export const getCodeToId = (code: string, items: Data[]) => {
  const filter = items.filter((i) => i.code === code)
  return filter && filter.length ? filter[0].id : ''
}

function checkImageWH(file: any, width: number, height: number) {
  return new Promise(function (resolve, reject) {
    const filereader = new FileReader()
    filereader.onload = (e) => {
      const src = e.target.result
      const image: any = new Image()
      image.onload = function () {
        if (width && this.width !== width) {
          message.error('上传图片的宽不符合要求，请重传!')
          return reject(new Error('上传图片的宽不符合要求，请重传!'))
        }
        if (height && this.height !== height) {
          message.error('上传图片的高不符合要求，请重传!')
          return reject(new Error('上传图片的高不符合要求，请重传!'))
        }
        return resolve(true)
      }
      image.onerror = reject
      image.src = src
    }
    filereader.readAsDataURL(file)
  })
}

export function beforePicUpload(file: any, { imgWidth, imgHeight, imgExtension, imgSize }) {
  const type = file.type.split('image/')[1]
  return new Promise<any>(function (resolve, reject) {
    const inCheckType = imgExtension.indexOf(type)
    if (inCheckType === -1) {
      message.error('图片格式不符合要求!')
      return reject(new Error('图片格式不符合要求!'))
    } else {
      const isSizeOut = imgSize ? file.size / 1024 > +imgSize : false
      if (isSizeOut) {
        message.error(`上传图片需小于${imgSize}kb!`)
        return reject(new Error(`上传图片需小于${imgSize}kb!`))
      } else {
        checkImageWH(file, +imgWidth, +imgHeight)
          .then(() => {
            return resolve(true)
          })
          .catch((err) => {})
      }
    }
  })
}

// 汉字限制长度型 中文字符长度占2，英文字符占1
export function restrictCNLength(value: string): number {
  if (!value) 0
  // 此正则表达式是将中文字符包括中文符号替换为两个英文英文字符，用以和后端计算字符长度协调
  const reg = new RegExp(
    [
      '[(\u4e00-\u9fa5)|\u3002|\uff1f|\uff01|',
      '\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|',
      '\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|',
      '\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|',
      '\u2026|\u2014|\uff5e|\ufe4f|\uffe5]{1}',
    ].join(''),
    'g'
  )
  if (value.replace(reg, 'sB').length) {
    return value.replace(reg, 'sB').length
  } else {
    return 0
  }
}

// 遍历数
export const mapTree = (data: any) => {
  data.forEach((item) => {
    item.title = item.cateName
    item.key = item.cateId
    if (item.children && item.children.length) {
      item.children = mapTree(item.children)
    }
  })
  return data
}
